module.exports = __webpack_public_path__ + "static/img/hongshi.8af626ce.png";